"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const Icon_1 = __importDefault(require("./Icon"));
function ShapesIcon(props, ref) {
    return (react_1.default.createElement(Icon_1.default, Object.assign({ ref: ref }, props),
        react_1.default.createElement("path", { d: "M11 14.6333C11 13.7313 10.2687 13 9.36667 13H5.63333C4.73127 13 4 13.7313 4 14.6333V18.3667C4 19.2687 4.73127 20 5.63333 20H9.36667C10.2687 20 11 19.2687 11 18.3667V14.6333Z" }),
        react_1.default.createElement("path", { d: "M13 16.5C13 18.433 14.567 20 16.5 20C18.433 20 20 18.433 20 16.5C20 14.567 18.433 13 16.5 13C14.567 13 13 14.567 13 16.5Z" }),
        react_1.default.createElement("path", { d: "M12.3412 5.3085C11.9475 4.69618 11.0525 4.69618 10.6588 5.3085L7.99049 9.45924C7.56266 10.1248 8.0405 11 8.83167 11H14.1683C14.9595 11 15.4373 10.1248 15.0095 9.45924L12.3412 5.3085Z" })));
}
exports.default = react_1.default.forwardRef(ShapesIcon);
